import Jsona from 'jsona';
import axios from 'axios';
import http from '../api/http';
import { remitActions } from '../slices/remit-slice';
import { isEmpty } from '../../library/utils';
import config from '../../config';

export const fetchPaymentOptionsByProductId = (
  productId,
  selectPaymentOptionId,
  accessToken
) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL +
    config.REACT_APP_PRODUCTS_DETAILS +
    productId;

  let request;
  if (accessToken) {
    request = axios.get(apiBaseUrl, {
      headers: {
        'X-Frame-Options': 'sameorigin',
        'X-XSS-Protection': '1; mode=block',
        'Strict-Transport-Security':
          'max-age=63072000; includeSubDomains; preload',
        'X-Content-Type-Options': 'nosniff',
        Authorization: 'Bearer ' + accessToken,
      },
    });
  } else {
    request = http.get(apiBaseUrl);
  }

  return (dispatch) => {
    dispatch(
      remitActions.setPaymentOptionsLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const product = new Jsona().deserialize(data);

        if (product.PaymentOption) {
          product.PaymentOption = product.PaymentOption?.map(function (option) {
            if (
              option.name.toString().toLowerCase().includes('temporary card')
            ) {
              option.name = 'Payment Link';
              return option;
            }

            if (
              (option.name.toString().toLowerCase().includes('debit') &&
                option.name.toString().toLowerCase().includes('credit')) ||
              (!option.name.toString().toLowerCase().includes('debit') &&
                !option.name.toString().toLowerCase().includes('credit'))
            ) {
              return option;
            }

            if (option.name.toString().toLowerCase().includes('debit'))
              option.name = option.name.replace('Debit', 'Debit/Credit');
            else if (option.name.toString().toLowerCase().includes('credit'))
              option.name = option.name.replace('Credit', 'Debit/Credit');

            return option;
          });
        }

        if (selectPaymentOptionId) {
          const selectPaymentOptionData = product.PaymentOption?.find(
            (p) => p.id?.toLowerCase() === selectPaymentOptionId.toLowerCase()
          );
          const selectPaymentOption = isEmpty(selectPaymentOptionData)
            ? null
            : {
                ...selectPaymentOptionData,
                provider:
                  selectPaymentOptionData.psp ??
                  selectPaymentOptionData.description,
              };
          dispatch(remitActions.setRemitPaymentOption(selectPaymentOption));
        } else {
          dispatch(
            remitActions.setPaymentOptions(
              product.PaymentOption?.map((po) => {
                return { ...po, provider: po.psp ?? po.description };
              })
            )
          );
        }
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Fetch Payment Options failed!';
          }
        }

        console.log(
          'Remit fetchPaymentOptionsByProductId error: ' + errorMessage
        );

        dispatch(remitActions.setPaymentOptionsError(errorMessage));
      }
    );
  };
};

export const selectRecipient = (id, accessToken) => {
  const apiBaseUrl =
    config.REACT_APP_IDENTITY_BASE_URL + config.REACT_APP_RECIPIENTS + '/' + id;

  let request;
  if (accessToken) {
    request = axios.get(apiBaseUrl, {
      headers: {
        'X-Frame-Options': 'sameorigin',
        'X-XSS-Protection': '1; mode=block',
        'Strict-Transport-Security':
          'max-age=63072000; includeSubDomains; preload',
        'X-Content-Type-Options': 'nosniff',
        Authorization: 'Bearer ' + accessToken,
      },
    });
  } else {
    request = http.get(apiBaseUrl);
  }

  return (dispatch) => {
    dispatch(
      remitActions.setRemitRecipientLoading({
        isLoading: true,
        willClearError: true,
      })
    );

    return request.then(
      ({ data }) => {
        const recipientData = new Jsona().deserialize(data);

        dispatch(
          remitActions.setRemitRecipient({
            ...recipientData,
            channelId: recipientData.channel?.id,
          })
        );
      },
      (error) => {
        let errorMessage = config.generalError;

        try {
          if (error.messages && typeof error.messages === 'string') {
            errorMessage = error.messages;
          } else if (
            error.response.data.message &&
            typeof error.response.data.message === 'string'
          ) {
            errorMessage = error.response.data.message;
          } else if (
            error.response.data.errors.message &&
            typeof error.response.data.errors.message === 'string'
          ) {
            errorMessage = error.response.data.errors.message;
          }
        } catch {
          console.log('error.response: ', error.response);
          console.log('error.request: ', error.request);
          console.log('error.config: ', error.config);
          if (error.response) {
            errorMessage = 'Fetch recipient failed!';
          }
        }

        console.log('Remit selectRecipient error: ' + errorMessage);

        dispatch(remitActions.setRemitRecipientError(errorMessage));
      }
    );
  };
};

export const selectRemitRecipient = (recipient) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitRecipient(recipient));
  };
};

export const resetRemitRecipient = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemitRecipient());
  };
};

export const setRemitProduct = (product) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitProduct(product));
  };
};

export const resetRemitProduct = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemitProduct());
  };
};

export const setRemitService = (service) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitService(service));
  };
};

export const resetRemitService = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemitService());
  };
};

export const selectRemitPaymentOption = (paymentOption) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitPaymentOption(paymentOption));
  };
};

export const resetRemitPaymentOption = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemitPaymentOption());
  };
};

export const setRemitAdditionalData = (remitAdditionalData) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitAdditionalData(remitAdditionalData));
  };
};

export const resetRemitAdditionalData = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemitAdditionalData());
  };
};

export const setConfirmedRemittance = () => {
  return (dispatch) => {
    dispatch(remitActions.setConfirmedRemittance());
  };
};

export const resetRemitKeepRecipient = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemitKeepRecipient());
  };
};

export const setRemitTransaction = (remittance) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitTransaction(remittance));
  };
};

export const setRemitSendingCountry = (sendingCountryCode) => {
  return (dispatch) => {
    dispatch(remitActions.setRemitSendingCountry(sendingCountryCode));
  };
};

export const resetRemit = () => {
  return (dispatch) => {
    dispatch(remitActions.clearRemit());
  };
};
